import { create } from "zustand";
import { persist } from "zustand/middleware";
import { Boat } from "../../models/boat/boat";

interface BoatDetails {
  boatYear?: Date;
  lastMaintenance?: Date;
  brand: string;
  model: string;
  color: string;
}

interface BoatStore {
  boat: BoatDetails;
  setBoatDetails: (address: BoatDetails) => void;
  clearBoatDetails: () => void;
}

export const useBoatDetailsStore = create(
  persist<BoatStore>(
    (set) => ({
      boat: {
        boatYear: new Date(),
        lastMaintenance: new Date(),
        brand: "",
        model: "",
        color: "",
      },
      setBoatDetails: (boat) => set({ boat: boat }),
      clearBoatDetails: () =>
        set({
          boat: {
            boatYear: new Date(),
            lastMaintenance: new Date(),
            brand: "",
            model: "",
            color: "",
          },
        }),
    }),
    { name: "createStoreDetails" }
  )
);

interface SelectedBoatStore {
  selectedBoat: Boat | undefined;
  setSelectedBoat: (boat: Boat | undefined) => void;
  clearSelectedBoat: () => void;
}

export const useSelectedBoatStore = create(
  persist<SelectedBoatStore>(
    (set) => ({
      selectedBoat: undefined,
      setSelectedBoat: (boat) => set({ selectedBoat: boat }),
      clearSelectedBoat: () => set({ selectedBoat: undefined }),
    }),
    {
      name: "selectedBoatStore",
    }
  )
);
